const isDevelopment = process.env.NODE_ENV === 'development';

export const API_BASE = process.env.REACT_APP_API_URL || (isDevelopment ? 'http://localhost:7031' : '');
export const MESSENGER_API_BASE = process.env.REACT_APP_MESSENGER_API_URL || (isDevelopment ? 'http://localhost:7032' : '/messenger');
export const NOTIFICATION_API_BASE = process.env.REACT_APP_NOTIFICATION_API_URL || (isDevelopment ? 'http://localhost:7033' : '/notifications');
